<div class="app-shell">
  <app-navbar [style.display]="showLayout() ? 'block' : 'none'"></app-navbar>
  <app-error-banner></app-error-banner>
  <main class="main-content" [class.main-with-navbar]="showLayout()">
    <router-outlet></router-outlet>
  </main>
</div>
